module.exports = __webpack_public_path__ + "img/volume-columns.702df8fc.png";